import { API_KEY as honeybadgerApiKey } from './honeybadger';
import { API_KEY as builderApiKey } from './builder';
import acceptedLocales from './acceptedLocales';

const config = {
  honeybadgerApiKey,
  builderApiKey,
  environment: process.env.NODE_ENV,
  acceptedLocales,
};

export default config;
